import WebApp from '@twa-dev/sdk';

export const lockScreenOrientation = () => {
  if (
    window?.screen?.orientation?.type === 'landscape-primary' ||
    window?.screen?.orientation?.type === 'landscape-secondary'
  ) {
    return;
  }

  WebApp.lockOrientation();
};
